import React, { useState, useRef, useEffect } from "react";
import { iconMap } from "../../../../constants/userManagement";
import ButtonNavigationBar from "../../../../component/buttonNavigationBar";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PersonalInfoSection from "../userComponent/personalInformationSection";
import TabSectionView from "../userComponent/tabSectionView";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useSelector } from "react-redux";
import Breadcrumb from "../../../../component/breadcrumb";
import { GrServices } from "react-icons/gr";
import { FaUser } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";

const BCrumb = [
  {
    to: "/app/user-management",
    title: "User Management",
  },
  {
    title: "View User",
  },
];
function UserView() {
  const { userManagementView } = useSelector((state) => state.counter);
  const { userType } = useSelector((state) => state.counter);
  const [activeStep, setActiveStep] = useState(0);
  const steps =
    userType === "business user"
      ? [
          "Store Details",
          "Bank Details",
          "Documents",
          "Services Offered",
        ]
      : ["Other Details", "Bank Details", "Documents"];

  // Refs for scrollable sections
  const otherRef = useRef(null);
  const bankRef = useRef(null);
  const docRef = useRef(null);
  const storeRef = useRef(null);
  const serviceRef = useRef(null);
  const [personalInformation, setPersonalInformation] = useState({});
  const [storeData, setStoreData] = useState({});
  const [bankData, setBankData] = useState({});
  const [otherDetails, setOtherDetails] = useState({});
  const [docs, setDocs] = useState([]);
  const [services, setServices] = useState([]);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const sectionRefs =
    userType === "business user"
      ? [storeRef, bankRef, docRef, serviceRef]
      : [otherRef, bankRef, docRef];

  useEffect(() => {
    constructPersonalData();
    constructBankDetails(userManagementView?.bankDetails?.[0]);
    if (
      userType === "business user" &&
      userManagementView?.stores?.length > 0
    ) {
      const store = userManagementView?.stores[0];
      constructStoreData(userManagementView?.stores[0]);
      setDocs(store?.uploadDoc || []);
      setServices(store?.services || []);
    }
    if (userType === "delivery user") {
      constructOtherDetails(userManagementView?.deliveryPerson);
      setDocs(userManagementView?.deliveryPerson?.uploadDoc || []);
    }
  }, []);

  const constructPersonalData = () => {
    let address = userManagementView?.addresses[0];
    const Personal = {
      "Full Name": userManagementView?.name,
      "Birth Date": userManagementView?.dob,
      Email: userManagementView?.email,
      Gender: userManagementView?.gender,
      "Mobile Number": userManagementView?.phone_number,
      Address:
        userManagementView?.addresses?.length > 0
          ? `${address?.house_no || ""}  ${address?.landmark || ""} ${
              address?.city || ""
            } ${address?.state || ""} - ${address?.zipcode || ""}`
          : "",
    };
    setPersonalInformation(Personal);
  };

  const constructStoreData = (store) => {
    let address = store?.storeAddresses[0];
    const storeData = {
      "Store Name": store?.storeName || "",
      "Store Contact Number": store?.store_phone || "",
      "Store License Number": store?.licenceNumber || "",
      "Store Address":
        store?.storeAddresses?.length > 0
          ? `${address?.house_no || ""} ${address?.landmark || ""} ${
              address?.city || ""
            } ${address?.state || ""} - ${address?.zipcode || ""}`
          : "",
      "Store Hours": store?.store_hours ? store?.store_hours : "",
    };
    setStoreData(storeData);
  };

  const constructBankDetails = (bank) => {
    const bankFields = {
      "Account Number": bank?.accountNumber,
      "Account Name": bank?.accountName,
      "Bank Name": bank?.bankName,
      "Routing Number": bank?.routingNumber,
    };
    setBankData(bankFields);
  };

  const constructOtherDetails = (delivery) => {
    const otherDetails = {
      "Vehicle Type": delivery?.vehicle_type,
      "License Plate Number": delivery?.vehicle_number,
    };
    setOtherDetails(otherDetails);
  };

  const stepHandler = (step) => {
    setActiveStep(step);
    sectionRefs[step]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const onSetDefault = (status) => {
    const payload = {
      isActive: status === "active" ? true : false,
    };
    

    // axiosInstance
    //   .patch(`/customer/store/campaign/${rowData.id}`, payload)
    //   .then(() => {
    //     fetchCampign();
    //   })
    //   .catch(() => {
    //     showSnackbar("Something went wrong!", "error");
    //   });
  };

  return (
    <div className="h-[calc(100vh-95px)] overflow-y-auto  hide-scrollbar">
      {/* Breadcrumb */}
      <div className="flex justify-between items-center mb-3 ml-4 mr-4 sm:ml-6">
        <Breadcrumb title="" items={BCrumb} />
        {/* <div className="font-[500] flex items-center justify-center">
          Preferred By Tidy
          <CustomSwitch
            // checked={!!row[column.field]}
            onChange={(e) => {
              onSetDefault(e.target.checked);
            }}
          />
        </div> */}
      </div>

      {/* Main Layout */}
      <div className="flex flex-col xl:flex-row mx-4 gap-4">
        {/* Left Panel */}
        <div className="w-full xl:w-[40%] bg-white rounded-[16px] shadow-md overflow-hidden border border-[#F1F1EF] h-auto xl:h-[calc(100vh-150px)]">
          <div
            className="h-[150px] w-full"
            style={{
              background:
                "linear-gradient(to right, #B2D8F7, #9CC8E2, #3383B2)",
            }}
          ></div>

          <div className="-mt-[75px] mb-1 pl-6">
            <div className="relative w-[120px] h-[120px] border-[4px] border-white rounded-full overflow-hidden shadow-md flex items-center justify-center bg-gray-100">
              {userManagementView?.profile_img_url ? (
                <>
                  {!isImageLoaded && (
                    <ImSpinner2 className="absolute animate-spin text-gray-400 text-3xl" />
                  )}
                  <img
                    src={userManagementView?.profile_img_url}
                    alt="Profile"
                    className={`h-full w-full object-cover transition-opacity duration-300 ${
                      isImageLoaded ? "opacity-100" : "opacity-0"
                    }`}
                    onLoad={() => setIsImageLoaded(true)}
                  />
                </>
              ) : (
                <FaUser className="text-gray-400 text-5xl" />
              )}
            </div>
          </div>
          <PersonalInfoSection
            iconMap={iconMap}
            personalInfo={personalInformation}
          />
        </div>

        {/* Right Panel */}
        <div className="w-full xl:w-[60%] flex flex-col h-auto lg:h-[calc(100vh-150px)]">
          <div className="w-full sticky top-0 z-10 pb-4 pl-2">
            <ButtonNavigationBar
              activeStep={activeStep}
              steps={steps}
              handleSteps={stepHandler}
            />
          </div>

          {/* Scrollable Content */}
          <div className="overflow-y-auto pr-2 hide-scrollbar max-h-[calc(100vh-200px)]">
            {userType === "business user" && (
              <div ref={storeRef} className="mb-3">
                <TabSectionView
                  title="Store Details"
                  icon={PersonOutlineIcon}
                  data={storeData}
                />
              </div>
            )}
            {userType === "delivery user" && (
              <div ref={otherRef} className="mb-3">
                <TabSectionView
                  title="Other Details"
                  icon={DeliveryDiningIcon}
                  data={otherDetails}
                />
              </div>
            )}
            <div ref={bankRef} className="mb-3">
              <TabSectionView
                title="Bank Details"
                icon={AccountBalanceIcon}
                data={bankData}
              />
            </div>
            <div ref={docRef} className="mb-3">
              <TabSectionView
                title="Uploaded Documents"
                icon={AssignmentIcon}
                uploadDoc={docs}
              />
            </div>
            {userType === "business user" && (
              <div ref={serviceRef} className="mb-3">
                <TabSectionView
                  title="Services Offered"
                  icon={GrServices}
                  services={services}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserView;
